<ng-container *ngIf="data.isSMA">
<div>
    Cash needs is not available for SMA accounts
</div>
</ng-container>
<ng-container *ngIf="!data.isSMA">
<div class="block bottomBorder" style="display: flex; flex-direction: row; gap: 15px;">
  <div style="width: 150px">
    <strong>Maintained Cash</strong>
    @if (!isCashEqvEnabled) {
      <span id="maintainedCashToolTipIcon" class="infoIcon toolTipIcon" calltoaction [calltoactionTemplate]="maintainedCashToolTipIcon"></span>
    }
  </div>
  <div>
    <div class="block">
    @if (isCashEqvEnabled) {
        Configure default cash targets to be maintained in your accounts. You can set a minimum for cash only and a range for cash and cash equivalents. At the account level, targets may be set as a % of account value or a specific $ amount.
    }
    @if (!isCashEqvEnabled) {
        Configure default cash targets to be maintained in your accounts. At the account level, targets may be set as a % of account value or a specific $ amount.
    }
    </div>
    @if (isCashEqvEnabled) {
    <div class="block"><irb-expando-link text="How does iRebal handle cash settings?">
    <div><b>Cash Only</b><br>
    You can set a minimum amount of transactional cash (otherwise known as everyday cash or operational cash) that can be used to purchase investments, pay bills, and manage daily expenses.
    </div>
    <div style="height:15px;"></div>
    <div><b>Cash & Cash Equivalents</b><br>
    Set a target for maintained cash and any cash equivalents, including purchased money market funds. iRebal will check each account's available cash, as well as any configured cash equivalents, to ensure they are inside your configured allocation range. Anything outside of this range will be brought to target.
    </div>
    <div style="height:15px;"></div>
    <div>Note: iRebal considers income cash to be available cash.</div>
    </irb-expando-link></div>
    <div class="dblock" style="display: flex; flex-direction: row; gap: 15px;">
        <div>
          <div>Cash Only</div>
          <irb-dropdown-filter #trxCashMinSettingRef
                   [value]="trxCashMinSetting"
                   (search)="populateTrxCashMinSettingDropdown($event)"
                   (selection)="setTrxCashMinSetting($event)"
                   [size]="19" [hoverPanelWidth]="160"></irb-dropdown-filter>
        </div>
        <div style="height:44px;width: 65px;">
          <div>&nbsp;</div>
          <p-radioButton
            name="is-percent-min" inputId="cashneedlitem11" [value]="'D'" [(ngModel)]="trxCashMinInd" [disabled]="trxCashMinSetting?.value === 'Set global'"
            (ngModelChange)="onExpressCashMinAs()"></p-radioButton>
            <label for="cashneedlitem11" style="margin-right:8px;">$</label>
          <p-radioButton
            name="is-percent-min" inputId="cashneedlitem12" [value]="'P'" [(ngModel)]="trxCashMinInd" [disabled]="trxCashMinSetting?.value === 'Set global'"
            (ngModelChange)="onExpressCashMinAs()"></p-radioButton>
            <label for="cashneedlitem12" >%</label>
        </div>
        <div>
          <div [ngClass]="{'disabled': trxCashMinSetting?.value === 'Set global'}"> Minimum</div>
          <irb-number-text-box *ngIf="trxCashMinSetting?.value !== 'Set global' && !(trxCashMinInd === 'D')"
                  #trxCashMinValueRef [(value)]="trxCashMinValue" (valueChange)="onTrxCashMinValueChange()"
                  invalidMessage="The value entered is not valid."
                  invalidRangeMessage="The value entered is not valid." width="145px"
                  [isPercentage]="true" [min]="-100" [max]="100" [places]="2"
                  [isRequired]="true"></irb-number-text-box>
          <irb-number-text-box *ngIf="trxCashMinSetting?.value !== 'Set global' && trxCashMinInd === 'D'"
                  #trxCashMinValueRef [(value)]="trxCashMinValue" (valueChange)="onTrxCashMinValueChange()"
                  invalidMessage="The value entered is not valid."
                  invalidRangeMessage="The value entered is not valid." width="145px"
                  [isCurrency]="true" [places]="0"
                  [isRequired]="true"></irb-number-text-box>
          <irb-number-text-box *ngIf="trxCashMinSetting?.value === 'Set global'"
                  [(value)]="data.globalTrxMinValue" width="145px"
                  [isPercentage]="true" [places]="2"  [disabled]="true"></irb-number-text-box>
        </div>
        <div class="clear"></div>
    </div>
    }
    <div class="hblock" style="display: flex; flex-direction: row; gap: 15px;">
        <div>
          <div>Cash & Cash Equivalents</div>
          <irb-dropdown-filter #cashEquivSettingRef
                   [value]="cashEquivSetting"
                   (search)="populateCashEquivSettingDropdown($event)"
                   (selection)="setCashEquivSetting($event)"
                   [size]="19" [hoverPanelWidth]="160"></irb-dropdown-filter>
        </div>
        <div style="height:44px;">
          <div>&nbsp;</div>
            <p-radioButton
                    name="is-percent" [value]="false" [(ngModel)]="data.isPercentage" [disabled]="data.isGlobal || data.useModelCashAtAccount"
                    (ngModelChange)="onExpressAs()" inputId="cashneedlitem3"></p-radioButton>
            <label for="cashneedlitem3" style="margin-right:8px;">$</label>
            <p-radioButton
                    name="is-percent" [value]="true" [(ngModel)]="data.isPercentage" [disabled]="data.isGlobal || data.useModelCashAtAccount"
                    (ngModelChange)="onExpressAs()" inputId="cashneedlitem4"></p-radioButton>
            <label for="cashneedlitem4">%</label>
        </div>
        <ng-container *ngIf="data.isPercentage && !((globalSettings?.useModelCash && data.isGlobal) || data.useModelCashAtAccount)">
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Minimum</div>
                <irb-number-text-box style="margin-left:2px;"
                      #cashMinPerc [(value)]="cashMinimum" (valueChange)="onCashMinPercentChange($event)"
                      invalidMessage="The value entered is not valid."
                      invalidRangeMessage="The value entered is not valid." width="145px"
                      [isPercentage]="true" [min]="-100" [max]="100" [places]="2"  [disabled]="data.isGlobal"
                      [maxConstraint]="cashTarget" [isRequired]="!data.isGlobal"
                      invalidMaxConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."></irb-number-text-box>
            </div>
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Target</div>
                <irb-number-text-box
                      #cashTargetPerc [(value)]="cashTarget" (valueChange)="onCashTargetPercentChange($event)"
                      invalidMessage="The value entered is not valid."
                      invalidRangeMessage="The value entered is not valid." width="145px"
                      [isPercentage]="true" [min]="-100" [max]="100" [places]="2" [disabled]="data.isGlobal"
                      [minConstraint]="cashMinimum" [maxConstraint]="cashMaximum" [isRequired]="!data.isGlobal"
                      invalidMinConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."
                      invalidMaxConstraintMessage="The value for cash max must be greater than or equal to the value for cash target."></irb-number-text-box>
            </div>
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Maximum</div>
                <irb-number-text-box
                      #cashMaxPerc [(value)]="cashMaximum" (valueChange)="onCashMaxPercentChange($event)"
                      invalidMessage="The value entered is not valid."
                      invalidRangeMessage="The value entered is not valid." width="145px"
                      [isPercentage]="true" [min]="-100" [max]="100" [places]="2" [disabled]="data.isGlobal"
                      [minConstraint]="cashTarget" [isRequired]="!data.isGlobal"
                      invalidMinConstraintMessage="The value for cash max must be greater than or equal to the value for cash target."></irb-number-text-box>
            </div>
        </ng-container>
        <ng-container *ngIf="!data.isPercentage && !((globalSettings?.useModelCash && data.isGlobal) || data.useModelCashAtAccount)">
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Minimum</div>
                <irb-number-text-box style="margin-left:2px;"
                      #cashMinDollar [(value)]="cashMinimum" (valueChange)="onCashMinDollarChange($event)"
                      invalidMessage="The value entered is not valid."
                      invalidRangeMessage="The value entered is not valid."
                      [isRequired]="!data.isGlobal"
                      width="145px" [isCurrency]="true" [disabled]="data.isGlobal"
                      [maxConstraint]="cashTarget"
                      invalidMaxConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."></irb-number-text-box>
            </div>
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Target</div>
                <irb-number-text-box
                      #cashTargetDollar [(value)]="cashTarget" (valueChange)="onCashTargetDollarChange($event)"
                      invalidMessage="The value entered is not valid."
                      invalidRangeMessage="The value entered is not valid."
                      width="145px" [isCurrency]="true" [disabled]="data.isGlobal"
                      [isRequired]="!data.isGlobal"
                      [minConstraint]="cashMinimum"
                      [maxConstraint]="cashMaximum"
                      invalidMinConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."
                      invalidMaxConstraintMessage="The value for cash max must be greater than or equal to the value for cash target."></irb-number-text-box>
            </div>
            <div>
              <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Maximum</div>
              <irb-number-text-box
                      #cashMaxDollar [(value)]="cashMaximum" (valueChange)="onCashMaxDollarChange($event)"
                      invalidMessage="The value entered is not valid."
                      invalidRangeMessage="The value entered is not valid."
                      width="145px" [isCurrency]="true" [disabled]="data.isGlobal"
                      [isRequired]="!data.isGlobal"
                      [minConstraint]="cashTarget"
                      invalidMinConstraintMessage="The value for cash max must be greater than or equal to the value for cash target."></irb-number-text-box>
            </div>
        </ng-container>
        <ng-container *ngIf="(globalSettings?.useModelCash && data.isGlobal) || data.useModelCashAtAccount">
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Minimum</div>
                <irb-number-text-box [disabled]="true" [placeholder]="modelFlag" width="145px"></irb-number-text-box>
            </div>
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Target</div>
                <irb-number-text-box [disabled]="true" [placeholder]="modelFlag" width="145px"></irb-number-text-box>
            </div>
            <div>
                <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Maximum</div>
                <irb-number-text-box [disabled]="true" [placeholder]="modelFlag" width="145px"></irb-number-text-box>
            </div>
        </ng-container>
        <div class="clear"></div>
    </div>
  </div>
</div>

<div [ngClass]="{'block': !isExternalAcct && !isSMA && isDistHoldCashEnabled, 'bottomBorder': !isExternalAcct && !isSMA && isDistHoldCashEnabled}" style="display: flex; flex-direction: row; gap: 15px;">
  <div style="width: 150px"><strong>Set Aside Cash</strong>
    <span id="setAsideCashToolTipIcon" class="infoIcon toolTipIcon" calltoaction [calltoactionTemplate]="setAsideCashToolTipIcon"></span>
  </div>  
  <div>
    <div class="block" *ngIf="ENABLE_SETASIDE_CASH && getSetAsideCount() > 0">
      {{getSetAsideCount()}} scheduled set aside cash amount<span *ngIf="getSetAsideCount() !== 1">s</span>
    </div>
    <div class="block" *ngIf="!ENABLE_SETASIDE_CASH">Enter start date and set-aside amount ($ or % of account)</div>
    <div class="block" *ngIf="ENABLE_SETASIDE_CASH">Configure settings for set-aside cash amount. After saving, you will need to run or schedule a rebalance before these settings can take effect.</div>
    <div class="block" style="display: flex; flex-direction: row; gap: 10px;">
      <div>
        <div>Start Date</div>
        <div class="mat-datepicker-container">
          <input matInput [matDatepicker]="startDatePicker" [min]="today" [formControl]="startDateControl" (dateChange)="onStartDateChange($event)"
            class="date-control" style="font-size: 13px; font-family: Arial; width: 120px;">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </div>
      </div>

      <div *ngIf="ENABLE_SETASIDE_CASH">
        <div>End Date (Optional)</div>
        <div class="mat-datepicker-container">
          <input matInput [matDatepicker]="endDatePicker" [min]="startDate" [(ngModel)]="endDate" (dateChange)="hideToolTip()"
            class="date-control" style="font-size: 13px; font-family: Arial; width: 120px;">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker [startAt]="endDateCalendarStartAt"></mat-datepicker>
        </div>
      </div>

      <div>
        <div>&nbsp;</div>
        <p-radioButton
          name="percent-dollar" inputId="cashneedlitem5" value="$" [(ngModel)]="setAsideAmountSymbol"
          (ngModelChange)="onSetAsideAmountSymbolChange()"></p-radioButton>
        <label for="cashneedlitem5" style="margin-right:10px;">$</label>
        <p-radioButton
          name="percent-dollar"inputId="cashneedlitem6" value="%" [(ngModel)]="setAsideAmountSymbol"
          (ngModelChange)="onSetAsideAmountSymbolChange()"></p-radioButton>
          <label for="cashneedlitem6" style="margin-right:10px;">%</label>
        <ng-container *ngIf="setAsideAmountSymbol === '%'">
          <irb-number-text-box
                  #setAsidePercent
                  invalidMessage="The value entered is not valid."
                  invalidRangeMessage="Percentage values cannot be greater than 100." width="120px"
                  [isPercentage]="true" [min]="0" [max]="100" [places]="2"
                  [(value)]="value"
                  (valueChange)="hideToolTip()"
                  [placeholder]="setAsideAmountPlaceholder"></irb-number-text-box>
        </ng-container>
        <ng-container *ngIf="setAsideAmountSymbol === '$'">
          <irb-number-text-box
                  #setAsideDollar
                  invalidMessage="The value entered is not valid."
                  invalidRangeMessage="The value entered is not valid." width="120px"
                  [isCurrency]="true" [min]="0"
                  [(value)]="value"
                  [places]="0"
                  (valueChange)="hideToolTip()"
                  [placeholder]="setAsideAmountPlaceholder"></irb-number-text-box>
        </ng-container>
      </div>

      <div>
        <div>Note</div>
        <input id="notes" type=text [(ngModel)]="notesToAdd" placeholder="Enter Notes" maxlength="50"
            style="font-size: 13px; font-family: Arial; width: 120px;">
      </div>

      <div>
        <div>&nbsp;</div>
        <button (click)="addToGrid()" class="btn-medium-primary" style="position: relative" [disabled]="disableAddButton()">Add
          <div *ngIf="tooltipShow" style="position:absolute;left:0;top:0;z-index: 9999; width: 70px; height: 30px" tooltip
              [tooltipPosition]="'right'" [tooltipTitle]="tooltipMessage" tooltipClass="error"></div>
        </button>
      </div>

      <div class="clear"></div>
    </div>
    <div class="cash-grid block" *ngIf="!isUiTest">
      <irb-inventory-grid
        [gridHeight]="'200px'"
        [showSideBar]="false"
        [gridOptions]="gridOptions"
        [frameworkComponents]='frameworkComponents'
        (gridReady)="onGridReady($event)"></irb-inventory-grid>
    </div>

<!--    <div class="cash-grid block" *ngIf="data.isSMA && !isUiTest">-->
<!--      <irb-inventory-grid-->
<!--        [gridHeight]="setAsideGridHeight"-->
<!--        [showSideBar]="false"-->
<!--        [gridOptions]="emptyGridOptions"-->
<!--        [frameworkComponents]='frameworkComponents'-->
<!--        (gridReady)="onEmptyGridReadyForSma($event)"></irb-inventory-grid>-->
<!--    </div>-->
    <div class="hint" *ngIf="ENABLE_SETASIDE_CASH">Totals are displayed in dollar amounts only. Percentage totals or combined dollar-and-percentage calculations are not displayed.</div>
  </div>
</div>

<div style="display: flex; flex-direction: row; gap: 15px;" *ngIf="!isExternalAcct && !isSMA && globalSettings && isDistHoldCashEnabled">
  <div style="width: 150px">
    <strong>Automatic Cash</strong><span id="autoCashHoldForDistToolTip" class="infoIcon toolTipIcon" calltoaction [calltoactionTemplate]="autoCashHoldForDistToolTip"></span><br/>
    <strong>Hold for</strong><br/>
    <strong>Distributions</strong>
  </div>
  <div>
    <div class="block">
        This feature is currently <span *ngIf="globalSettings.autoCashHoldForDist">enabled</span><span *ngIf="!globalSettings.autoCashHoldForDist">disabled</span> globally. You can modify this from iRebal settings. <a (click)="openGlobalSettings()">Go to Settings</a>
    </div>
    <div class="block">
      <div class="hblock">
        <div class="hblock">Account setting</div>
        <p-radioButton name="autoCashHoldForDist" [disabled]="!globalSettings.autoCashHoldForDist" [value]="true" [(ngModel)]="data.autoCashHoldForDist" (ngModelChange)="toggleAutoCashHoldForDist()" inputId="cashneedlitem9"></p-radioButton>
          <label for="cashneedlitem9" style="margin-right:10px;">On</label>
          <p-radioButton name="autoCashHoldForDist" [disabled]="!globalSettings.autoCashHoldForDist" [value]="false" [(ngModel)]="data.autoCashHoldForDist" (ngModelChange)="toggleAutoCashHoldForDist()" inputId="cashneedlitem10"></p-radioButton>
          <label for="cashneedlitem10">Off</label>
      </div>
      <div class="hint">Turn on or turn off an automatic cash hold for this account.</div>
    </div>
    <div>
      <div class="hblock">
        <span>Cash hold</span>
        <span style="margin: 0 10px" *ngIf="showAutoCashHoldForDist">{{data.autoCashHoldForDistAmt | currency:'USD'}}</span>
        <span style="margin: 0 10px" *ngIf="!showAutoCashHoldForDist">$0</span>
      </div>
      <div class="hint">Cash hold for the next {{globalSettings.autoCashHoldForDistWindow}} days will be calculated automatically for each account.</div>
    </div>
  </div>
</div>
</ng-container>


<ng-template #maintainedCashToolTipIcon>
  <div class="block">iRebal ensures an account maintains a certain amount of cash within the minimum cash and maximum cash amounts. Global defaults from Settings are applied unless you override them here.</div>
  <div>Note: iRebal considers income cash available cash. If you want to hold income cash aside, enter the cash amount in the account's set-aside cash (below).</div>
</ng-template>

<ng-template #setAsideCashToolTipIcon>
  <div>For rebalancing, iRebal will set aside a specific amount over and above the maintained cash amount. This set-aside cash amount will not be figured into the portfolio's cash allocation. You can schedule various set-aside amounts and set separate start dates for each.</div>
</ng-template>

<ng-template #autoCashHoldForDistToolTip>
  Distribution hold is the amount of upcoming distributions from the account. This amount will be treated as set-aside cash.
</ng-template>
